'use strict';

import {Vector2} from 'three';
import {getCanvasWidthDiff, renderUpdateValuesOnDemand, updateRaycaster} from '../../app';
import { closeAsideMenu } from '../menu/menu';
import { isMobile, projectMode, settingsData, threeJsVariables } from '../../settings';
import {checkIntersection} from "../threejs/raycast";
import { closePoiInfoWindowCardInOrbit } from '../poi/poiCss';
import { autoRotateTimerAction } from './orbitControls';
import { PublicLayers } from '../components/publicLayers/PublicLayers';
import { Environment } from '../components/Environment/Environment';
import { PointViewManager } from '../components/pointViewManager/PointViewManager';

let doubleClickTimer = '';
let mouseMoveEvent, isPressed;
let timeOne = null;
let prevSelectedObject = null;

export const RaycastHandler = (settings) => {
    const canvas = document.getElementById('c');

    ['pointerup', 'pointerdown', 'pointermove'].forEach(itemEvent => {
        canvas.addEventListener(itemEvent, (event) => {
            mouseHandler(event, settings, canvas);
            renderUpdateValuesOnDemand(false);
            settingsData.last_interaction = Date.now();
        }, true);
    });
}

let pointersArray = [];

function mouseHandler(event, settings, canvas) {
    if (projectMode.LiteMode.preventPointerEvents(undefined))
        return;

    settingsData.isClickEvent = event.pointerType === 'mouse';
    settingsData.isTouchEvent = event.pointerType === 'touch';
    const canvasSize = threeJsVariables.renderer.getSize(new Vector2());
    const canvasDiff = getCanvasWidthDiff();

    if (!canvas)
        return;
    
    if (projectMode.AirMode.active && projectMode.AirMode.isVisible()) {
        threeJsVariables.mouse.x = ((event.clientX - canvasDiff.x) / canvasSize.x) * 2 - 1;
        threeJsVariables.mouse.y = -(event.clientY / canvasSize.y) * 2 + 1;
        threeJsVariables.mouse.winX = event.clientX;
        threeJsVariables.mouse.winY = event.clientY;
        return;
    }

    switch (event.type) {

        case 'pointerdown': {
            autoRotateTimerAction('update');
            if (settingsData.bombBlock)
                return;

            settingsData.isClickEvent = event.pointerType === 'mouse';
            settingsData.isTouchEvent = event.pointerType === 'touch';

            mouseMoveEvent = Date.now();
            isPressed = true;

            if (pointersArray.indexOf(event.pointerId) === -1)
                pointersArray.push(event.pointerId);

            threeJsVariables.mouse.x = ((event.clientX - canvasDiff.x) / canvasSize.x) * 2 - 1;
            threeJsVariables.mouse.y = -(event.clientY / canvasSize.y) * 2 + 1;
            threeJsVariables.mouse.winX = event.clientX;
            threeJsVariables.mouse.winY = event.clientY;
            closeAsideMenu();

            isMobile
                ? closePoiInfoWindowCardInOrbit(true)
                : closePoiInfoWindowCardInOrbit(false, false);

            updateRaycaster();
            pointerDownHandler();
            break;
        }
        case 'pointermove':
            if (isPressed && Date.now() - mouseMoveEvent >= 100) {
                // dragHandler();
                settingsData.intersectionBlock = true;
                PointViewManager.closePortals();
                PublicLayers.intersect();
                Environment.intersect();
            }

            threeJsVariables.mouse.x = ((event.clientX - canvasDiff.x) / canvasSize.x) * 2 - 1;
            threeJsVariables.mouse.y = -(event.clientY / canvasSize.y) * 2 + 1;
            threeJsVariables.mouse.winX = event.clientX;
            threeJsVariables.mouse.winY = event.clientY;

            updateRaycaster();
            // updateMousePosition(event);
            PublicLayers.intersect('update');
            Environment.intersect('update');

            settingsData.isIntersection = true;
            break;
        case 'pointerup': {
            if (pointersArray.length > 1 && !pointersArray.length) {
                pointersArray = [];
                resetPointerCoords();
                return;
            }
            pointersArray = [];

            isPressed = false;
            (Date.now() - mouseMoveEvent >= 300)
                ? resetPointerCoords()
                : clickHandler(settings);

            settingsData.intersectionBlock = false;

            break;
        }
    }
}

function clickHandler() {
    resetPointerCoords();
    checkIntersection('click');
}

function dragHandler() {
    resetPointerCoords();
    checkIntersection('drag');
}

function pointerDownHandler() {
    resetPointerCoords();
    checkIntersection('pointerdown');
}

export function doubleEventCheck(selectedObject) {
    // const diff = Date.now() - doubleClickTimer;

    switch (selectedObject.userData.type) {
        case 'building':
        case 'neighborhood':
            prevSelectedObject = settingsData.selectedObject;
            break;
        case 'selectionBoxes':
            prevSelectedObject = settingsData.lastClickedFlat;
            break;
    }


    if (doubleClickTimer && Date.now() - doubleClickTimer < 300 && prevSelectedObject !== null && selectedObject === prevSelectedObject ) {
        settingsData.doubleClick = true;
        setTimeout(() => {settingsData.doubleClick = false}, 100)
    } else {
        settingsData.doubleClick = false;
        doubleClickTimer = Date.now();
    }

    return settingsData.doubleClick;
}

function resetPointerCoords() {
    threeJsVariables.mouse.x = -10000;
    threeJsVariables.mouse.y = -10000;
    settingsData.current_mouse_position.x = -10000;
    settingsData.current_mouse_position.y = -10000;
}
